<app-ui-button
  [ngClass]="[buttonClass]"
  buttonType="icon-button"
  [iconVariant]="iconVariant"
  icon="person"
  (click)="navigateToPerson($event)"
></app-ui-button>
